import { type GeoResultItem } from "$/utils/fetchGeoData";
import { type AddressInfo } from "@/modal/openAddressModal";

export const checkAddress = (address?: AddressInfo): address is AddressInfo => {
  if (!address) {
    return false;
  }
  const { residenceCountry, geoInfos, postcode, ...restAddresses } = address;
  const parts: string[] = [];
  parts.push(...geoInfos.map((item) => item.name));
  parts.push(
    ...[residenceCountry, ...addressMapToList(restAddresses), postcode],
  );
  return Boolean(parts.filter((item) => item).join(""));
};

// 地址输入框表单名前缀
export const addressNamePrefix = "address_";

// 表单地址输入框字段转化为接口addresses列表
export const addressMapToList = (addressGroup: Record<string, string>) => {
  return (
    Object.entries(addressGroup)
      .sort(([key1], [key2]) => (key1 < key2 ? -1 : 1))
      // 表单拿到的值可能是null，手动修复格式
      .map(([_, value]) => value || "")
  );
};

// 接口addresses列表转化为表单地址输入框字段
export const addressListToMap = (addresses: string[]) => {
  return addresses.reduce((acc, cur, idx) => {
    return {
      ...acc,
      [`${addressNamePrefix}${idx}`]: cur,
    };
  }, {});
};

export const parseGeoResults = (geoResults: GeoResultItem[]) => {
  if (geoResults.length === 0) {
    return {};
  }
  const { parents = [], current } = geoResults[0]!;
  const [level1, level2] = parents;
  if (!level1 || !level2) {
    return {};
  }
  return {
    geoInfos: [
      {
        id: level1.id,
        name: level1.name,
      },
      {
        id: level2.id,
        name: level2.name,
      },
      {
        id: current.id,
        name: current.name,
      },
    ],
  };
};
